export type SupportContactChannel = 'phone' | 'whatsapp' | 'email';

export interface SupportContact {
  channel: SupportContactChannel;
  label: string;
  href: string;
}

export const SUPPORT_CONTACTS: SupportContact[] = [
  { channel: 'phone', label: '0800 725 1105', href: 'tel:08007251105' },
  {
    channel: 'whatsapp',
    label: '(71) 99687-1537',
    href: 'https://wa.me/5571996871537',
  },
  {
    channel: 'email',
    label: 'atendimento@alba.com.br',
    href: 'mailto:atendimento@alba.com.br',
  },
];
